<mat-card *ngIf="card.display != 'Off'" style="min-height: 100px; padding: 0; display: flex; flex-direction: row;">
    <div style="display: flex; flex-direction: column; flex: 1">
        <div class="header-color" style="display: flex; flex-direction: row;">
            <div class="robotoMedium" style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;">
                <span translate>Enrollment</span>
            </div>
        </div>
        <div style="display: flex; flex-direction: row; flex: 1; flex-wrap: wrap; justify-content: center">
            <div style="width: 100%;">
                <mat-accordion [displayMode]="'flat'" [multi]="true" class="mat-elevation-z0">
                    <mat-expansion-panel *ngIf="enrollmentDetails.length > 0" [expanded]="true" class="mat-elevation-z0" style="border-bottom-style: solid;border-bottom-width: 1px;border-bottom-color: lightgray;">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Details
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <!-- Content Area -->
                        <div *ngIf="v10" style="width: 100%">
                            <mat-table style="width: 100%; position: relative; margin-top: -24px" [dataSource]="enrollmentDetails">
                                <!-- Prior District Column -->
                                <ng-container matColumnDef="priorDistrict">
                                    <mat-header-cell style="padding-left: 12px; flex-grow: 2" *matHeaderCellDef>Prior District</mat-header-cell>
                                    <mat-cell style="padding-left: 12px; flex-grow: 2" *matCellDef="let e"> {{e.PriorDistrict}} </mat-cell>
                                </ng-container>

                                <!-- Prior State Column -->
                                <ng-container matColumnDef="priorState">
                                    <mat-header-cell style="flex: 1" *matHeaderCellDef>Prior State</mat-header-cell>
                                    <mat-cell style="flex: 1" *matCellDef="let e">{{e.PriorState}}</mat-cell>
                                </ng-container>

                                <!-- Prior Country Column -->
                                <ng-container matColumnDef="priorCountry">
                                    <mat-header-cell style="flex: 1" *matHeaderCellDef>Prior Country</mat-header-cell>
                                    <mat-cell style="flex: 1" *matCellDef="let e">{{e.PriorCountry}}</mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                <mat-row style="min-height: 30px;" *matRowDef="let row; columns: displayedColumns;"></mat-row>
                            </mat-table>
                            <!-- Extra details -->
                            <div style="display: flex;padding-top: 15px;padding-left: 12px;">
                                <div style="display: flex; flex: 1.5; flex-direction: column">
                                    <div class="row-details">
                                        <div class="row-detail-label">Name/Photo in Newspapers</div>
                                        <div class="row-detail-content">{{enrollmentDetails[0].InNewsPapers ? 'Y' : 'N'}}</div>
                                    </div>
                                    <div class="row-details">
                                        <div class="row-detail-label">Use info in Athletic Publications</div>
                                        <div class="row-detail-content">{{enrollmentDetails[0].AthleticPublications ? 'Y' : 'N'}}</div>
                                    </div>
                                    <div class="row-details">
                                        <div class="row-detail-label">Use info in School Publications</div>
                                        <div class="row-detail-content">{{enrollmentDetails[0].SchoolPublications ? 'Y' : 'N'}}</div>
                                    </div>
                                </div>
                                <div style="display: flex; flex: 1; flex-direction: column">
                                    <div class="row-details">
                                        <div class="row-detail-label">Directory Information</div>
                                        <div class="row-detail-content">{{enrollmentDetails[0].DirectoryInformation ? 'Y' : 'N'}}</div>
                                    </div>
                                    <div class="row-details">
                                        <div class="row-detail-label">Include in Class Rank</div>
                                        <div class="row-detail-content">{{enrollmentDetails[0].IncludeInClassRank ? 'Y' : 'N'}}</div>
                                    </div>
                                    <div class="row-details">
                                        <div class="row-detail-label">Armed Forces</div>
                                        <div class="row-detail-content">{{enrollmentDetails[0].ArmedForces ? 'Y' : 'N'}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="!v10" style="width: 100%">
                            <div style="display: flex; flex: 1; flex-direction: column; padding-left: 12px">
                                <div style="display: flex; flex: 1; padding-bottom: 5px">
                                    <div class="row-detail-label" style="flex: 1">Prior District</div>
                                    <div style="display: flex; flex: 3">{{enrollmentDetails[0].PriorDistrict}}</div>
                                </div>
                                <div style="display: flex; flex: 1; padding-bottom: 5px">
                                    <div class="row-detail-label" style="flex: 1">Include in class Rank</div>
                                    <div style="display: flex; flex: 3">{{enrollmentDetails[0].IncludeInClassRank ? 'Y' : 'N'}}</div>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                    <mat-expansion-panel *ngIf="enrollmentHistory.length > 0" [expanded]="true" class="mat-elevation-z0">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                History
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div>
                            <mat-table style="width: 100%;" multiTemplateDataRows [dataSource]="angularMatData" class="mat-elevation-z0">

                                <!-- Year Column -->
                                <ng-container matColumnDef="year">
                                    <mat-header-cell *matHeaderCellDef style="flex: 1"><span translate>Year</span></mat-header-cell>
                                    <mat-cell *matCellDef="let e" style="flex: 1">{{e.AcademicYearDesc}}</mat-cell>
                                </ng-container>

                                <!-- School Column -->
                                <ng-container matColumnDef="school">
                                    <mat-header-cell *matHeaderCellDef style="flex: 4"><span translate>School</span></mat-header-cell>
                                    <mat-cell *matCellDef="let e" style="flex: 4">{{e.SchoolName}}</mat-cell>
                                </ng-container>

                                <!-- Grade Column -->
                                <ng-container matColumnDef="grade">
                                    <mat-header-cell *matHeaderCellDef style="flex: 1"><span translate>Grade</span></mat-header-cell>
                                    <mat-cell *matCellDef="let e" style="flex: 1">{{e.GradeLevel}}</mat-cell>
                                </ng-container>

                                <!-- Grade Column -->
                                <ng-container matColumnDef="enrolled">
                                    <mat-header-cell *matHeaderCellDef style="flex: 1"><span translate>Enrolled</span></mat-header-cell>
                                    <mat-cell *matCellDef="let e" style="flex: 1">{{e.EnrolledDate | date:'MM/dd/yy'}}</mat-cell>
                                </ng-container>


                                <!-- More Column -->
                                <ng-container matColumnDef="more">
                                    <mat-header-cell *matHeaderCellDef style="min-width:68px;max-width:68px;text-align:center;" class="print-ignore"></mat-header-cell>
                                    <mat-cell *matCellDef="let AH" style="min-width:68px;max-width:68px;justify-content: center;" class="print-ignore">
                                        <span aria-label="Expand row for more details">
                                            <i [ngClass]="checkExpanded(AH) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" aria-hidden="true"></i>
                                        </span>
                                    </mat-cell>
                                </ng-container>

                                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                                <ng-container matColumnDef="expandedDetail">
                                    <!-- Detail row can have standard html or another Angular Material table -->
                                    <mat-cell *matCellDef="let enrollmentRecord" [attr.colspan]="historyColumns.length" style="width:100%;">
                                        <div style="flex: 1; display: flex;">
                                            <div style="display: flex; flex: 1; flex-direction: column" >
                                                <div class="row-detail-label" style="display: flex; flex: 1; padding-bottom: 5px">Enrollment Code</div>
                                                <div style="display: flex; flex: 1">{{enrollmentRecord.EnrollmentCode}}</div>
                                            </div>
                                            <!-- For V10 -->
                                            <div *ngIf="this.v10" style="display: flex; flex: 2; flex-direction: column" >
                                                <div class="row-detail-label" style="display: flex; flex: 1; padding-bottom: 5px">Membership Code</div>
                                                <div style="display: flex; flex: 1" *ngIf="!enrollmentRecord.MultipleMembershipCodeValues">{{enrollmentRecord.MembershipCode}}</div>
                                                <div style="display: flex; flex: 1" *ngIf="enrollmentRecord.MultipleMembershipCodeValues"><a (click)="openMembershipCodeDetails(enrollmentRecord.RSNY_ID, enrollmentRecord.MembershipCode)">{{enrollmentRecord.MembershipCode}}</a></div>
                                            </div>
                                            <!-- For V9 -->
                                            <div *ngIf="!this.v10" style="display: flex; flex: 2; flex-direction: column" >
                                                <div class="row-detail-label" style="display: flex; flex: 1; padding-bottom: 5px">FTE</div>
                                                <div style="display: flex; flex: 1">{{enrollmentRecord.MembershipCode}}</div>
                                            </div>
                                            <div style="display: flex; flex: 1; flex-direction: column" >
                                                <div class="row-detail-label" style="display: flex; flex: 1; padding-bottom: 5px">Withdrawal</div>
                                                <div style="display: flex; flex: 1">{{enrollmentRecord.WithdrawalDate | date: 'MM/dd/yy'}}</div>
                                            </div>
                                            <div style="display: flex; flex: 1; flex-direction: column" >
                                                <div class="row-detail-label" style="display: flex; flex: 1; padding-bottom: 5px">Code</div>
                                                <div style="display: flex; flex: 1">{{enrollmentRecord.WithdrawalCode}}</div>
                                            </div>
                                        </div>
                                    </mat-cell>
                                </ng-container>

                                <mat-header-row  *matHeaderRowDef="historyColumns; sticky: false"></mat-header-row>
                                <!-- Data rows -->
                                <mat-row *matRowDef="let row; columns: historyColumns; let i = index;"
                                         id = "AHdataRow{{i}}"
                                         tabindex="0"
                                         [ngStyle]="{'border-bottom-width':checkExpanded(row) ? '0px' : '1px'}"
                                         [ngClass]="{'pastEnrollment' : row.IsCurrent == false}"
                                         style="padding:0;overflow: hidden;"
                                         matRipple
                                         (click)="toggleExpanded(row)"
                                         (keydown)="rowKeyPress($event, row)">
                                </mat-row>
                                <!-- Detail row -->
                                <!-- 'overflow: hidden' is required for animation to render properly -->
                                <mat-row *matRowDef="let row; columns: ['expandedDetail']" [@detailExpand]="checkExpanded(row) ? 'expanded' : 'collapsed'" style="overflow: hidden;">
                                </mat-row>
                            </mat-table>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
    </div>
</mat-card>
